export default __webpack_public_path__ + "static/media/zenodo-login.dda8e805.png";